export const getDetails = state => {
    return state.details
}


// WEBPACK FOOTER //
// ./src/store/modules/events/getters.js